import React from "react";

import { Navbar, Nav, NavItem, Col, Row, Collapse, NavLink, } from "reactstrap";
import { Label } from "semantic-ui-react";

const Piepagina = () => {
  return (

    <div className="footer">
      <div className="contain">
        <Row>
          <Col lg={3} md={3} sm={6}>
            <div className="col">
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={3} md={3} sm={6}>
            <div className="col">
              <ul>
                <li>
                  <a href="https://www.aig.com.ec/quienes-somos" target="_blank" style={{ color: "#a8a8aa" }}>Nuestra compañía</a>
                </li>
                <li>
                  <a href="https://www.aig.com.ec/transparencia-informacion" target="_blank" style={{ color: "#a8a8aa" }}>Transparencia de la Información</a>
                </li>
                <li>
                  <a href="https://aig-pdfs.s3-us-west-2.amazonaws.com/Compensacio%CC%81n+al+productor+ai.pdf" target="_blank" style={{ color: "#a8a8aa" }}>Política de Compensación al Productor</a>
                </li>
              </ul>
            </div>
          </Col>
          <Col lg={3} md={3} sm={6}>
            <div className="col">
              <ul>
                <li>
                  <a href="https://www.aig.com.ec/programa-educacion" target="_blank" style={{ color: "#a8a8aa" }}>Programa de Educación Financiera</a>
                </li>
                <li>
                  <a href="https://www.aig.com.ec/trabaja-nosotros" target="_blank" style={{ color: "#a8a8aa" }}>Trabaja con Nosotros</a>
                </li>
                <li>
                  <a href="https://www.aig.com.ec/contactanos" target="_blank" style={{ color: "#a8a8aa" }}>Contáctanos</a>
                </li>
                <li>
                  <a href="https://www.aig.com.ec/personas/soporte-a-clientes" target="_blank" style={{ color: "#a8a8aa" }}>Soporte al Cliente</a>
                </li>
              </ul>
            </div>
          </Col>
          <Col lg={3} md={3} sm={6}>
            <div className="col">
              <ul>
                <li>
                  <a href="https://www.aig.com.ec/siniestros" target="_blank" style={{ color: "#a8a8aa" }}>Siniestros</a>
                </li>
                <li>
                  <a href="https://www.aig.com.ec/sitemap" target="_blank" style={{ color: "#a8a8aa", pointerEvents: "none" }}>Mapa del sito</a>
                </li>
                <li>
                  <a href="https://www.aig.com.ec/noticias" target="_blank" style={{ color: "#a8a8aa", pointerEvents: "none" }}>Noticias</a>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={8} md={7} sm={7}>
            <div className="col">
              <ul>
                <li>
                  <span>Ecuador |</span><a href="https://www.aig.com/worldwide" target="_blank" style={{ color: "#a8a8aa" }}> AIG en el Mundo </a>
                </li>
              </ul>
            </div>
          </Col>
          <Col lg={4} md={5} sm={5}>
            <div className="col">
              <ul>
                <h1>Contáctanos</h1>
                <li>
                  <table className={"table-logo-footer"}>
                    <tbody>
                      <tr>
                        <td className={"letras-nombre-logo-pie"}>1800 AIG AIG</td>
                      </tr>
                      <tr>
                        <td className={"letras-telefono-logo-pie"}>244-244</td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12} md={12} sm={12}>
            <div className="col">
              <ul>
                <li>
                  <a href="https://www.aig.com.ec/terminos-condiciones" target="_blank" style={{ color: "#ffff" }}>Terminos y Condiciones de Uso</a> {" | "} <a href="https://www.aig.com.ec/privacidad" target="_blank" style={{ color: "#ffff" }}>Política de Privacidad</a>
                </li>
                <li>
                  {`Copyright © ${(new Date().getFullYear())} AIG-Metropolitana Cía. de Seguros y Reaseguros S.A. Todos los derechos reservados.`}
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>
    </div>
    /*
    <div className="footer">
    <div className="contain">
      <div className="col">
        <ul>
          <h1>Ubicación</h1>
          <li>
            <a href="https://www.aig.com.ec/" target="_blank" style={{ color: "#a8a8aaf" }}>Sitio Informativo</a>
          </li>
        </ul>
      </div>
      <div className="col">
        <ul>
          <h1>Información</h1>
          <li>
            <a href="https://s3-us-west-2.amazonaws.com/aig-pdfs/1560807201206269378.pdf" target="_blank" style={{ color: "#a8a8aaf" }}>Términos y Condiciones</a>
          </li>
          <li>
            <a href="/preguntas-frecuentes" style={{ color: "#a8a8aaf" }}>Preguntas Frecuentes</a>
          </li>
        </ul>
      </div>
      <div className="col">
        <ul>
          <h1>Canales de Atención</h1>
          <li>
            <a href="https://www.aig.com.ec/contactanos" target="_blank" style={{ color: "#a8a8aaf" }}>Contáctanos</a>
          </li>
        </ul>
      </div>
      <div className="col">
        <ul>
          <h1>Contáctanos</h1>
          <li>
            <table className={"table-logo-footer"}>
              <tr>
                <td className={"letras-nombre-logo-pie"}>1800 AIG AIG</td>
              </tr>
              <tr>
                <td className={"letras-telefono-logo-pie"}>244-244</td>
              </tr>
            </table>
          </li>
        </ul>
      </div>
    </div>
  </div>
  */
  );
};

export default Piepagina;
